'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { useHeaderMainSection } from './use-header-main-section';
export function HeaderMainSection(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const containerRef = useHeaderMainSection();
  let t1;
  if ($[0] !== children || $[1] !== containerRef) {
    t1 = <div ref={containerRef} className="header__main-section-container">{children}</div>;
    $[0] = children;
    $[1] = containerRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}